import React from 'react';

export const valueOrEmpty = (value?: string | number | null | React.JSX.Element) => value || '-';
